<template>
  <div>
    <b-tabs active-nav-item-class="font-weight-bold text-light bg-info">
      <b-tab
        :title="itemRegOp.name"
        v-for="(itemRegOp, indRegOp) in operatsiya"
        v-if="!itemRegOp.deleted"
        :key="indRegOp"
        :class="{ kasallikT: $route.name == 'ArxivOne' }"
        title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
        style="padding: 0px !important;"
      >
        <div class="tek-card">
          <div>
            <div
              class="shif-sarlovha"
              :class="{
                Arxive: $route.name == 'ArxivOne',
                vazvrat: itemRegOp.vazvrat == true
              }"
            >
              <div
                style="display: flex; justify-content: space-between; width: 450px;"
              >
                <div v-if="!$store.state.kasTar">
                  <b-button
                    :disabled="
                      !(
                        localUser.doctor_id == itemRegOp.doctor_id ||
                        localUser.role == 'Admin'
                      )
                    "
                    class="navbarBtnTashxis"
                    v-b-modal="
                      'modal-shablon' + indRegOp + 'operatsiya' + modalIdCom
                    "
                    @click="getShablon"
                    variant="primary"
                  >
                    <b-icon icon="collection"></b-icon>
                  </b-button>
                  <b-modal
                    :id="'modal-shablon' + indRegOp + 'operatsiya' + modalIdCom"
                    size="lg"
                    :title="$t('Шаблонлар рўйхати')"
                    hide-footer
                  >
                    <!-- :modalId="modalId" -->
                    <Shablon
                      :indRegShif="indRegOp"
                      :modalIdCom="modalIdCom"
                      :shabType="'operatsiya'"
                      :itemsShablon="itemsShablon"
                      @ShablonGet="getShablon"
                      @RowClickedShab="RowClickedShab"
                    />
                  </b-modal>
                </div>
                <b-button
                  style="margin-left: 10px; margin-right: 10px;"
                  variant="primary"
                  @click="allPechat(itemRegOp, 'text')"
                  class="navbarBtnTashxis"
                >
                  <b-icon icon="printer-fill"></b-icon>
                  Печать
                </b-button>
                <b-button
                  :disabled="
                    localUser.doctor_id != itemRegOp.doctor_id &&
                      localUser.role != 'Admin'
                  "
                  style="margin-left: 10px; margin-right: 10px;"
                  variant="primary"
                  @click="clicknewShablon(indRegOp)"
                  v-b-modal="
                    'modal-new-shab-creat-oper' + indRegOp + modalIdCom
                  "
                  class="navbarBtnTashxis"
                >
                  <b-icon icon="arrow-up-circle-fill"></b-icon>
                </b-button>
                <b-modal
                  :id="'modal-new-shab-creat-oper' + indRegOp + modalIdCom"
                  :title="$t('Шифокор шаблон')"
                  hide-footer
                >
                  <div>
                    <div>
                      <b-input type="text" v-model="newShablon.name"></b-input>
                    </div>
                  </div>
                  <div class="CreateName">
                    <b-button
                      class="modalBtn1"
                      size="sm"
                      style="height: 37px;"
                      variant="danger "
                      @click="ShifokorShablonClose(indRegOp)"
                    >
                      <b-icon icon="calendar2-x"></b-icon>
                      {{ $t("Бекор қилиш") }}
                    </b-button>
                    <b-button
                      class="mt-3 ml-2 modalBtn"
                      @click="ShifokorShablon(indRegOp)"
                      variant="success"
                    >
                      <b-icon icon="calendar2-plus"></b-icon>
                      {{ $t("Сақлаш") }}
                    </b-button>
                  </div>
                </b-modal>
                <!-- <b-button
                  class="navbarBtnTashxis"
                  v-if="!$store.state.kasTar"
                  v-b-modal="'modal-qosh' + indRegOp + modalIdCom"
                  @click="getQoshimcha"
                  variant="primary"
                >
                  <b-icon icon="plus-circle-fill"></b-icon>
                </b-button> -->
                <b-modal
                  :id="'modal-qosh' + indRegOp + modalIdCom"
                  size="xl"
                  hide-footer
                >
                  <!-- <Shifokor :shifokor="qoshimcha" :index="indRegOp" @itemSh="itemOpReg"/> -->
                  <OperatsiyaVue
                    :operatsiyalar="qoshimcha"
                    :index="indRegOp"
                    @itemOper="QoshimchaAdd"
                  />
                </b-modal>
                <!-- <div>
                  <v-select
                    class="oper-select"
                    :disabled="
                      itemRegOp.doctor_id != localUser.doctor_id &&
                        localUser.role != 'Admin' &&
                        localUser.role != 'Registrator'
                    "
                    label="name"
                    style="width: 250px; margin-left: 5px;"
                    :options="Shifokorlar"
                    :reduce="option => option.id"
                    v-model="itemRegOp.doctor_id"
                  />
                </div> -->
                <input
                  type="datetime-local"
                  class="input-datetime-local"
                  v-model="itemRegOp.date_doctor"
                />
              </div>
              <div class="delete-vaz">
                <div
                  class="shif-price"
                  v-if="
                    localUser.role != 'Loborant' &&
                      localUser.role != 'Uzi ' &&
                      localUser.role != 'Shifokor'
                  "
                >
                  <div style="width: 130px;">
                    {{ itemRegOp.price | numFormat }}
                  </div>
                  <button
                    v-if="localUser.role == 'Admin' || localUser.role == 'Registrator' || localUser.role == 'Katta hamshira'"
                    class="navbarBtnTashxis-summa navbarBtnTashxis"
                    v-b-modal="
                      'modal-summa-change-oper' + indRegOp + modalIdCom
                    "
                    @click="OperPrice = itemRegOp.price"
                  >
                    <b-icon style="width: 15px;" icon="pencil-fill"></b-icon>
                  </button>
                  <b-modal
                    :id="'modal-summa-change-oper' + indRegOp + modalIdCom"
                    :title="itemRegOp.name"
                    hide-footer
                  >
                    <div style="width: 100%;">
                      <vue-numeric
                        class="numberic-pay"
                        separator="space"
                        :precision="2"
                        v-model="OperPrice"
                      ></vue-numeric>
                    </div>
                    <div class="CreateName">
                      <b-button
                        class="modalBtn1"
                        size="sm"
                        style="height: 37px;"
                        variant="danger "
                        @click="close(indRegOp)"
                      >
                        <b-icon icon="calendar2-x"></b-icon>
                        {{ $t("Бекор қилиш") }}
                      </b-button>
                      <b-button
                        class="mt-3 ml-2 modalBtn"
                        @click="Change(itemRegOp, indRegOp)"
                        variant="success"
                      >
                        <b-icon icon="calendar2-plus"></b-icon>
                        {{ $t("Сақлаш") }}
                      </b-button>
                    </div>
                  </b-modal>
                </div>
                <div
                  class="shif-price"
                  v-if="
                    localUser.role != 'Loborant' &&
                      localUser.role != 'Uzi ' &&
                      localUser.role != 'Shifokor'
                  "
                >
                  <div style="width: 130px;">
                    {{ itemRegOp.all_summa | numFormat }}
                  </div>
                </div>
                <!-- <div style="width: 100px;">
                  <b-form-checkbox
                    :class="{ kasallikT: $store.state.kasTar }"
                    style="display: flex; width: 100px;"
                    v-model="itemRegOp.vazvrat"
                    v-if="
                      localUser.role == 'Kasser' ||
                        localUser.role == 'Admin' ||
                        localUser.role == 'Registrator'
                    "
                    @change="Vazvrat(itemRegOp, indRegOp)"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Возврат
                  </b-form-checkbox>
                </div> -->
                <b-button
                  :class="{ kasallikT: $store.state.kasTar }"
                  v-if="
                    !itemRegOp.pay_summa &&
                      !itemRegOp.vazvrat &&
                      (localUser.role == 'Admin' ||
                        localUser.role == 'Kasser' ||
                        localUser.role == 'Registrator' ||
                        itemRegOp.date_time > dateDeleted)
                  "
                  style="width: 30px; height: 30px; display: flex; justify-content: center;"
                  @click="deleteOper(indRegOp, itemRegOp)"
                  variant="outline-danger"
                >
                  <b-icon style="width: 17px;" icon="trash"></b-icon>
                </b-button>
              </div>
            </div>
            <!-- <div>
              <Qoshimcha
                :qoshimcha="itemRegOp.surgery_doctor"
                :classvazvrat="itemRegOp.vazvrat"
                :backlog="backlog"
                :modalIdCom="modalIdCom"
                @SummaChange="SummaChange"
                @vazvratQoshimcha="vazvratQoshimcha"
                :indOta="indRegOp"
                @delQosh="delQosh"
              />
            </div> -->
          </div>
          <div
            :class="{ kasallikT: $store.state.kasTar }"
            class="tashxis-style"
          >
            <!-- <div>
              <div>
                <div class="oper-header-text">
                  <div>
                    {{ $t("Операцияга қадар") }}
                  </div>
                  <div>
                    <b-button
                      style="margin-left: 10px; margin-right: 10px;"
                      variant="primary"
                      @click="allPechat(itemRegOp, 'before_sur_text')"
                      class="navbarBtnTashxis"
                    >
                      <b-icon icon="printer-fill"></b-icon>
                      Печать
                    </b-button>
                  </div>
                </div>
                <VueEditorText
                  :text="itemRegOp.before_sur_text"
                  :indReg="indRegOp"
                  :disabled="
                    localUser.doctor_id == itemRegOp.doctor_id ||
                    localUser.role == 'Admin'
                      ? false
                      : true
                  "
                  :textValue="'before_sur_text'"
                  :defaultHeigth="defaultHeigth"
                  @vueEditorText="vueEditorText"
                  @textChangeValueIndex="textChangeValueIndex"
                />
              </div>
            </div> -->

            <div>
              <!-- <div class="oper-header-text">
                <div>
                  {{ $t("Операция") }}
                </div>
                <div>
                  <b-button
                    style="margin-left: 10px; margin-right: 10px;"
                    variant="primary"
                    @click="allPechat(itemRegOp, 'text')"
                    class="navbarBtnTashxis"
                  >
                    <b-icon icon="printer-fill"></b-icon>
                    Печать
                  </b-button>
                </div>
              </div> -->
              <VueEditorText
                :text="itemRegOp.text"
                :indReg="indRegOp"
                :textValue="'text'"
                :disabled="
                  localUser.doctor_id == itemRegOp.doctor_id ||
                  localUser.role == 'Admin'
                    ? false
                    : true
                "
                :table_type="itemRegOp.table_type"
                :defaultHeigth="defaultHeigth"
                @vueEditorText="vueEditorText"
                @textChangeValueIndex="textChangeValueIndex"
              />
            </div>

            <!-- <div>
              <div class="oper-header-text">
                <div>
                  {{ $t("Операциядан кейин") }}
                </div>
                <div>
                  <b-button
                    style="margin-left: 10px; margin-right: 10px;"
                    variant="primary"
                    @click="allPechat(itemRegOp, 'after_sur_text')"
                    class="navbarBtnTashxis"
                  >
                    <b-icon icon="printer-fill"></b-icon>
                    Печать
                  </b-button>
                </div>
              </div>
              <VueEditorText
                :text="itemRegOp.after_sur_text"
                :indReg="indRegOp"
                :disabled="
                  localUser.doctor_id == itemRegOp.doctor_id ||
                  localUser.role == 'Admin'
                    ? false
                    : true
                "
                :textValue="'after_sur_text'"
                :defaultHeigth="defaultHeigth"
                @vueEditorText="vueEditorText"
                @textChangeValueIndex="textChangeValueIndex"
              />
            </div> -->
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
// import Shifokor from '../Shifokor/Shifokor.vue';
import VueEditorText from "../VueEditorText.vue";
import Shablon from "../Shifokor/Shablon.vue";
import Qoshimcha from "../Qoshimcha.vue";
import OperatsiyaVue from "./Operatsiya.vue";
export default {
  props: ["operatsiya", "backlog", "modalIdCom", "created_at", "dateDeleted"],
  components: {
    // Shifokor,
    Shablon,
    OperatsiyaVue,
    Qoshimcha,
    VueEditorText
  },
  data() {
    return {
      newShablon: {
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        text: "",
        doc_type: "operatsiya"
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      qoshimcha: [],
      itemsShablon: [],
      Shifokorlar: [],
      defaultHeigth: "height: 960px;",
      textChangeValue: {
        index: null,
        key: null
      },
      OperPrice: 0
    };
  },
  methods: {
    getQoshimcha() {
      let self = this;
      axios({
        method: "get",
        url: "/surgery_category/all"
      }).then(res => {
        if (res) {
          self.qoshimcha = res.data.data;
        }
      });
    },
    ShifokorShablonClose(index) {
      this.newShablon = {
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        text: "",
        doc_type: "operatsiya"
      };
      this.$bvModal.hide(
        `${"modal-new-shab-creat-oper" + index + this.modalIdCom}`
      );
    },
    ShifokorShablon(index) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: self.newShablon
      }).then(res => {
        if (res) {
          self.newShablon = {
            name: "",
            text: "",
            doctor_id: JSON.parse(localStorage.getItem("user")).id,
            doc_type: "operatsiya"
          };
          self.$bvModal.hide(
            `${"modal-new-shab-creat-oper" + index + self.modalIdCom}`
          );
        }
      });
    },
    clicknewShablon(index) {
      this.newShablon.text = this.operatsiya[index].text.toString();
      // this.newShablon.table_type = this.operatsiya[index].table_type
    },
    QoshimchaAdd(item, index) {
      let x = null;
      if (this.$store.state.bemor.citizen) {
        x = item.citizen_price;
      } else {
        x = item.price;
      }
      this.operatsiya[index].all_summa += x;
      this.operatsiya[index].update = true;

      this.$emit("shifAdd", x, true);
      this.operatsiya[index].surgery_doctor.push({
        category_id: item.id,
        name: item.name,
        price: x,
        doctor_id: item.doctor_id,
        backlog: +x,
        discount: 0,
        pay_summa: 0,
        key: new Date().valueOf().toString(),
        vazvrat: false
      });
    },
    close(ind) {
      this.OperPrice = 0;
      this.$bvModal.hide("modal-summa-change-oper" + ind + this.modalIdCom);
    },
    Change(item, ind) {
      this.$emit("delShif", item.price, false);
      this.$emit("SummaChange", this.OperPrice, true);
      this.operatsiya[ind].price = this.OperPrice;
      this.operatsiya[ind].backlog = this.OperPrice;
      this.operatsiya[ind].update = true;
      this.$bvModal.hide("modal-summa-change-oper" + ind + this.modalIdCom);
    },
    delQosh(x, index, type) {
      this.operatsiya[index].all_summa -= x;
      this.operatsiya[index].update = true;
      this.$emit("delShif", x, type);
    },
    vazvratQoshimcha(x, type, v, index, item) {
      if (type == true) {
        this.operatsiya[index].all_summa -= x;
      } else {
        this.operatsiya[index].all_summa += x;
      }
      this.operatsiya[index].update = true;
      this.$emit("delShif", x, type, v, item);
    },
    deleteOper(ind, item) {
      let operatsiyaSum = item.price;
      let qoshimchaSum = item.all_summa;
      let x = qoshimchaSum + operatsiyaSum;
      this.$emit("delShif", x, false);
      this.operatsiya[ind].deleted = true;
      this.operatsiya.splice(ind, 1);
    },
    Vazvrat(item, ind) {
      let x = "vazvrat";
      let price = item.price + item.all_summa;
      this.operatsiya[ind].update = true;
      this.$emit("delShif", price, item.vazvrat, x, item);
    },
    getShablon() {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: self.localUser.id,
          doc_type: "operatsiya"
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    vueEditorText(val, index, indexChild, textValue, type) {
      this.operatsiya[index][`${textValue}`] = val;
      this.operatsiya[index].update = true;
      if (
        type &&
        (this.localUser.role == "Admin" || this.localUser.role == "Loborant")
      ) {
        this.operatsiya[index].update = true;
      }
    },
    textChangeValueIndex(key, index) {
      this.textChangeValue = {
        index: index,
        key: key
      };
    },
    RowClickedShab($events, ind) {
      // this.operatsiya[ind].text += $events.text;
      // this.operatsiya[ind].update = true;

      let text = JSON.parse(this.operatsiya[ind].text.toString());
      let shablonText = JSON.parse($events.text.toString());
      this.operatsiya[ind].update = true;
      this.operatsiya[ind].table_type = $events.table_type;
      for (let index = 0; index < shablonText.length; index++) {
        const el = shablonText[index];
        if (text[index]) {
          text[index][`${text[index].key}`] = el[`${el.key}`];
        } else {
          text.push(el);
        }
      }
      // text[0].value += $events.text
      this.operatsiya[ind].text = JSON.stringify(text);
      this.textChangeValue = {
        index: null,
        key: null
      };
      this.$bvModal.hide(
        `${"modal-shablon" + ind + "operatsiya" + this.modalIdCom}`
      );
    },
    SummaChange(price, index, type) {
      this.operatsiya[index].all_summa += price;
      this.operatsiya[index].update = true;
      this.$emit("shifAdd", price, type);
    },
    allPechat(item, key) {
      let t = [];
      let x = [];
      x.push(item);
      t = {
        key: key ? key : false,
        bemorId: this.$store.state.bemor.id,
        name: this.$store.state.bemor.fullname,
        gender: this.$store.state.bemor.gender,
        birthday: this.$store.state.bemor.birthday,
        create_at: this.created_at,
        doctor: x
      };
      localStorage.setItem("Bayonot", JSON.stringify(t));
      // this.$router.push("/user");
      const rout = this.$router.resolve({
        path: "/user/operatsiya"
      });
      window.open(rout.href, "_blank");
      this.pechatTek = [];
    },
    getShifokor() {
      let self = this;
      axios({
        method: "get",
        url: "/doctor/all"
      }).then(res => {
        if (res) {
          self.Shifokorlar = res.data;
        }
      });
    }
  },
  mounted() {
    this.getShifokor();
  }
};
</script>
<style>
.oper-select .vs__selected-options span:first-child {
  width: 88% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.oper-select .vs__selected-options {
  width: 88%;
}
.oper-header-text {
  font-size: 20px;
  font-weight: 700;
  width: 100%;
  padding: 5px;
  display: flex;
  background: rgba(7, 100, 172, 0.058);
  border: 1px solid rgb(70, 112, 250);
  border-radius: 10px;
  color: rgb(70, 112, 250);
}
</style>
